var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1122_41961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C19.1645 32 22.2579 31.0616 24.8891 29.3035C27.5203 27.5454 29.5711 25.0466 30.7821 22.1229C31.9931 19.1993 32.3099 15.9823 31.6926 12.8786C31.0752 9.77486 29.5513 6.92393 27.3137 4.68629C25.0761 2.44865 22.2251 0.924799 19.1214 0.307436C16.0177 -0.309929 12.8007 0.00692558 9.87707 1.21793C6.95345 2.42893 4.45459 4.47969 2.69649 7.11088C0.938384 9.74206 2.38913e-07 12.8355 0 16H3.2C3.2 13.4684 3.95071 10.9936 5.35719 8.8887C6.76367 6.78375 8.76276 5.14314 11.1017 4.17434C13.4405 3.20554 16.0142 2.95206 18.4972 3.44595C20.9801 3.93984 23.2609 5.15892 25.051 6.94903C26.8411 8.73915 28.0602 11.0199 28.5541 13.5028C29.0479 15.9858 28.7945 18.5595 27.8257 20.8983C26.8569 23.2372 25.2162 25.2363 23.1113 26.6428C21.0063 28.0493 18.5316 28.8 16 28.8V32Z",
    fill: "url(#paint0_linear_1122_41961)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1122_41961)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#A100FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1122_41961",
    x1: 0,
    y1: 16,
    x2: 59.6115,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A100FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF50A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskgroup);
export default __webpack_public_path__ + "static/media/Mask group.0ccba9de3d221b68aa30c971806ec318.svg";
export { ForwardRef as ReactComponent };